import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AboutSupportSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const appVersion = 'v2.0.4';
  const buildNumber = '2045';

  const handleCopyVersion = () => {
    const versionInfo = `Winglet ${appVersion} (Build ${buildNumber})`;
    navigator?.clipboard?.writeText(versionInfo);
  };

  const handleCheckUpdates = () => {
    console.log('Checking for updates...');
  };

  return (
    <div className="card">
      <div 
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-xl bg-accent-cyan/20 glow-subtle">
            <Icon name="Info" size={20} color="var(--color-accent-cyan)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground">About & Support</h2>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              App information and help resources
            </p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={24} 
          color="var(--color-muted-foreground)" 
        />
      </div>

      {isExpanded && (
        <div className="mt-6 md:mt-8 space-y-6 md:space-y-8">
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">App Version</h3>
            <div className="p-4 rounded-lg bg-tertiary border border-accent-cyan/20">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-foreground">Winglet {appVersion}</p>
                  <p className="text-xs text-muted-foreground">Build {buildNumber}</p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="Copy"
                  onClick={handleCopyVersion}
                >
                  Copy
                </Button>
              </div>
            </div>
            <Button
              variant="outline"
              iconName="RefreshCw"
              iconPosition="left"
              onClick={handleCheckUpdates}
              className="mt-4"
            >
              Check for Updates
            </Button>
          </div>

          <div className="h-px bg-accent-cyan/20"></div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Help & Documentation</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <Button
                variant="outline"
                iconName="Book"
                iconPosition="left"
                className="justify-start"
              >
                User Guide
              </Button>
              <Button
                variant="outline"
                iconName="Video"
                iconPosition="left"
                className="justify-start"
              >
                Video Tutorials
              </Button>
              <Button
                variant="outline"
                iconName="HelpCircle"
                iconPosition="left"
                className="justify-start"
              >
                FAQ
              </Button>
              <Button
                variant="outline"
                iconName="MessageCircle"
                iconPosition="left"
                className="justify-start"
              >
                Community Forum
              </Button>
            </div>
          </div>

          <div className="h-px bg-accent-cyan/20"></div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Contact Support</h3>
            <Button
              variant="default"
              iconName="Mail"
              iconPosition="left"
            >
              Contact Support
            </Button>
          </div>

          <div className="h-px bg-accent-cyan/20"></div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Legal</h3>
            <div className="space-y-2">
              <Button
                variant="ghost"
                className="justify-start w-full"
              >
                Terms of Service
              </Button>
              <Button
                variant="ghost"
                className="justify-start w-full"
              >
                Privacy Policy
              </Button>
              <Button
                variant="ghost"
                className="justify-start w-full"
              >
                Open Source Licenses
              </Button>
              <Button
                variant="ghost"
                className="justify-start w-full"
              >
                Acknowledgments
              </Button>
            </div>
          </div>

          <div className="h-px bg-accent-cyan/20"></div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Rate the App</h3>
            <Button
              variant="outline"
              iconName="Star"
              iconPosition="left"
            >
              Rate Winglet
            </Button>
          </div>

          <div className="h-px bg-accent-cyan/20"></div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Social Media</h3>
            <div className="flex gap-3">
              <Button
                variant="ghost"
                size="icon"
                iconName="Twitter"
              />
              <Button
                variant="ghost"
                size="icon"
                iconName="MessageSquare"
              />
              <Button
                variant="ghost"
                size="icon"
                iconName="Share2"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutSupportSection;